import axios from 'axios';
import { TEST_API_BASE_URL, PRE_API_BASE_URL, BASE_URL } from '@/utils/config';
import { datafluxRum } from '@cloudcare/browser-rum';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_ENV === 'staging') {
    return TEST_API_BASE_URL;
  }
  if (process.env.REACT_APP_ENV === 'pre') {
    return PRE_API_BASE_URL;
  }
  if (process.env.REACT_APP_ENV === 'production') {
    return BASE_URL;
  }

  if (process.env.REACT_APP_ENV === 'development') {
    if (process.env.REACT_APP_API_BASE_URL) {
      // 通过 copy .env.example .env 文件配置
      return process.env.REACT_APP_API_BASE_URL;
    }
    return 'http://localhost:3000/';
  }

  // Default to production API URL or add other environments as needed
  return BASE_URL; // replace with actual production API URL
};

export const API_BASE_URL = getApiBaseUrl();

console.log('API_BASE_URL', API_BASE_URL);

axios.defaults.withCredentials = true;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL
});

axiosInstance.interceptors.request.use(
  async (config) => {
    if(process.env.REACT_APP_ENV === 'production') {
      //@ts-ignore
      if (window?.Clerk?.session) {
      //@ts-ignore
        config.headers.Authorization = `Bearer ${await window.Clerk.session.getToken()}`
      }
    } else {
      //@ts-ignore
      if (window?.Clerk?.session) {
      //@ts-ignore
      config.headers.Authorization = `Bearer ${await window.Clerk.session.getToken({template: 'testing-template'})}`;
      }
    }
    return config;
  },
  (error) => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 设置拦截器处理响应
axiosInstance.interceptors.response.use(
  (response) => {
    // this should not happen but let's leave it as is for now
    if (response.data && response.data.code !== 0 && response.config.responseType !== 'blob') {
      // message.error(`non-zero non-error response: ${response.data.message}`);
      return Promise.reject({ 
        code: response.data.code,
        error: response.data.message 
      });
    }
    return response; // 如果没有错误，正常返回响应
  },
  (error) => {
    // 上报接口 HTTP 错误到观测云（不含 Network Error）
    if (axios.isAxiosError(error) && error.response) {
      const status = error.response.status;
      const url = error.config?.url || error.config?.baseURL || 'unknown';
      const method = error.config?.method?.toUpperCase() || 'unknown';

      if (status !== 401 && typeof datafluxRum?.addError === 'function') {
        try {
          datafluxRum.addError(
            new Error(`API Error: ${method} ${url} - ${status}`),
            {
              source: 'axios',
              type: 'http_error',
              status,
              url,
              method,
              message: error.response?.data?.message || error.message,
              code: error.response?.data?.code,
            }
          );
        } catch (e) {
          // 静默失败，不影响主流程
        }
      }
    }
    // 网络错误（error.request && !error.response）不再上报

    if (error.response?.status === 401) {
      // 会话过期，跳转到登录页面
      // redirectToAuthPage();
      return Promise.reject({ message: error.response?.data?.message }); // 返回拒绝承诺阻止进一步处理
    }
    // 处理 HTTP 请求错误情况
    if (axios.isAxiosError(error) && error.response) {
      //TODO: remove global message error in the future to prevent duplication
      // message.error(error.response.data?.message);
      return Promise.reject({ message: error.response?.data?.message, payload: error.response?.data?.payload, code: error.response?.data?.code });
    }
    // 后续提示内容可标准化
    // message.error('Unknown Error');
    return Promise.reject(error?.response?.data); // Internal Server Error
  }
);

export default axiosInstance;
